<template>
    <div>
        <h1>{{ t('links.title') }}</h1>
        <v-card v-for="link in localLinks" :key="link.title">
            <v-card-title>{{ link.title }}</v-card-title>
            <v-card-text>
                <a :href="link.url" target="blank">{{ link.url }}</a>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState,} from "vuex";
import { useI18n } from 'vue-i18n';
export default {
    setup() {
        const { t } = useI18n();
        return { t };
    },
    data() {
        return {
            localLinks: []
        };
    },
    mounted() {
        this.localLinks = this.links;
    },
    computed: {
        ...mapState([ "links",]),
    }
}
</script>
<style>
</style>